export const BxDetailIcon = ({ className }) => {
  return (
    <svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.3333 2H2.66665C1.93131 2 1.33331 2.598 1.33331 3.33333V12.6667C1.33331 13.402 1.93131 14 2.66665 14H13.3333C14.0686 14 14.6666 13.402 14.6666 12.6667V3.33333C14.6666 2.598 14.0686 2 13.3333 2ZM2.66665 12.6667V3.33333H13.3333L13.3346 12.6667H2.66665Z" fill="#0774B3" />
      <path d="M4 4.66797H12V6.0013H4V4.66797ZM4 7.33464H12V8.66797H4V7.33464ZM4 10.0013H8V11.3346H4V10.0013Z" fill="currentColor" />
    </svg>

  )
}